export enum FieldResultEnum {
  DayOfWeek = 'day_of_week',
  DayOfWeekIndex = 'day_of_week_index',
  MonthName = 'month_name',
  QuarterOfYear = 'quarter_of_year',
  Ts = 'ts',
  Yesno = 'yesno',
  //
  String = 'string',
  Number = 'number',
  //
  Date = 'date',
  Boolean = 'boolean',
  Array = 'array',
  Record = 'record',
  Json = 'json',
  SqlNative = 'sql_native'
}
